exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Lato);", ""]);

// module
exports.push([module.id, "body{color:#4a4a4a;height:100%}body *,body :after,body :before{box-sizing:border-box}body *{font-family:Lato,sans-serif}@media screen{body{margin:0;padding:0}#root,html{height:100%}#root>div{min-height:100%;position:relative}.transcript-container *{font-family:Times New Roman,serif}}@media print{body{margin:0}.transcript-container{background-color:#fff}.transcript-container *{font-family:Georgia}.page-break-avoid{page-break-inside:avoid;page-break-after:auto}.page-break-after{page-break-after:always}a.xref:after{content:\" (page \" target-counter(attr(href,url),page) \")\"}}.conference-number-dropdown-item{padding-left:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./style.css
// module id = 286
// module chunks = 0